<template>
    <ion-segment :value="currentOrderType" mode="ios" class="ion-padding-bottom order-type-toggle" v-if="showToolbar">
        <ion-segment-button v-for="orderType in OrderTypeEnum" :key="orderType" :value="orderType" @click="changeOrderType(orderType)" :data-cy="'order-type-' + orderType">
            <ion-label class="interstate-bold order-type-toggle">{{ orderType }}</ion-label>
        </ion-segment-button>
    </ion-segment>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { IonSegment, IonSegmentButton, IonLabel } from '@ionic/vue';
import { OrderTypeEnum } from '@/enums/OrderTypeEnum';

export default defineComponent({
    props: { modelValue: Boolean, showToolbar: Boolean },
    components: { IonSegment, IonSegmentButton, IonLabel },
    setup(props, { emit }) {
        const localModelValue = computed({
            // isDelivery
            get: () => props.modelValue,
            set: (newValue) => emit('update:modelValue', newValue),
        });
        const currentOrderType = computed(() => (localModelValue.value ? OrderTypeEnum.delivery : OrderTypeEnum.pickup));
        const changeOrderType = (type) => (localModelValue.value = OrderTypeEnum.delivery == type);
        return { OrderTypeEnum, changeOrderType, currentOrderType, localModelValue };
    },
});
</script>

<style scoped>
ion-segment {
    background: white;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    border-radius: 40px;
    z-index: 3;
    padding: unset;
    margin: 20px auto;
    width: 70%;
    min-width: 300px;
}

ion-segment-button {
    --color: var(--ion-color-dark);
    font-size: 1.5em;
    height: 50px;
    --border-width: unset;
}

ion-segment-button.ios::part(indicator-background) {
    border-radius: 40px;
}
.segment-button-checked.ios::part(native) {
    color: #fff;
}

ion-segment-button::part(indicator-background) {
    background: var(--ion-color-secondary-shade);
}
</style>
